import BaseComponent from '@/components/base';
import { StyleCta } from '@/components/style/style-cta';
import { FontStyle } from '@/components/style';

export default class FragranceModal extends BaseComponent {
  style = `
  <style>
  .image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 25rem;
    background-image: url('https://s3-alpha-sig.figma.com/img/118c/5504/411dc3b3cb0b10466b70cca75810e7ee?Expires=1713744000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=jf7WRM-vIvabKZbKBxyth8vbOkiqE2c5TDb8Twyx0a6j~0RsSA-DjdDr4hpJI1bg3FPxr9YEnFu404x-b5mrIGWm3gHTT5nrYuA0cvAkWRSMtf00h-V-QPvmsmpRNcHqKCBZbjDTYzEg95VLrk7iNxMw6KIHvUYQBc2kjMXlTs0CCTuNb1isnQUlYBWO56VX0pnlRE2YiHpZCenJIBcE3h~hLcPe7aA9kxXm1XBioWW673mAqodfdxw1JvAdDD5dzBpAGFqicdruJId2s2eNZrqJyQ2LCdhuc2MEiQhxR2IPstE-jyFAr52v0L2M6YGX67F926P~y5l7ZAPjows-0w__')

  }
   .description {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
    .description-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

</style>
  `;
  render() {
    return `
    <modal-component enabled="${this.enabled}" modal-width="366px" >
        ${StyleCta}
        ${FontStyle}
        ${this.style}
        <div style="display: flex; flex-direction: row; gap: 10px">
            <div class="image"></div>
            <div class="description">
                <div class="description-header">
                    <div class="description-title title-font-9">
                        ${this.name ?? 'Product Name'}
                    </div>
                    <div class="stars"></div>
                </div>
                <div class="description-legend body-font-2">
                ${this.description ?? 'Product Description'}
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.
                </div>
                <div class="description-color">
                    Color: <span class="description-color-name">Product Color</span>
                </div>
            </div>
        </div>
        <fragrance-select is-recovery="true" enable-base="true" enable-small="true"></fragrance-select>
        <div style="display: flex; justify-content: center; align-items: center">
            <button id="regimenToCheckoutButton" class="cta-1 add-all" style="max-width: 300px">add to order</button>
        </div>
    </modal-component>
    `;
  }

  get enabled() {
    return this.getAttribute('enabled') === 'true';
  }

  set enable(value) {
    this.shadowRoot.querySelector('modal-component').enabled = value;
  }

  get name() {
    return this.getAttribute('name');
  }

  set name(value) {
    this.setAttribute('name', value);
    this.shadowRoot.querySelector('.description-title').innerText = value;
  }

  get description() {
    return this.getAttribute('description');
  }

  set description(value) {
    this.setAttribute('description', value);
    this.shadowRoot.querySelector('.description-legend').innerText = value;
  }

  get color() {
    return this.getAttribute('color');
  }

  set color(value) {
    this.setAttribute('color', value);
    this.shadowRoot.querySelector('.description-color-name').innerText = value;
  }

  get image() {
    return this.getAttribute('image');
  }

  set image(value) {
    this.setAttribute('image', value);

    this.shadowRoot.querySelector('.image').style.backgroundImage =
      `url('${value}')`;
  }

  afterMount() {
    // this.querySelector('#regimenToCheckoutButton')
  }
}
